import { HHTextField } from '@hinge-health/react-component-library';
import Autocomplete from '@mui/material/Autocomplete';
import { Controller } from 'react-hook-form';
import { useGetPaymentTypesQuery } from '../../types';
import { selectSorterFunction } from '../../utils/bills-utils';
import { BaseFilterProps, StatusFilterLabelText } from './filter-types';

export const PaymentTypeFilter = ({
  control,
  errors,
}: BaseFilterProps): JSX.Element => {
  const { data: paymentTypesData } = useGetPaymentTypesQuery();

  const paymentTypesOptions =
    paymentTypesData?.getPaymentTypes
      ?.map(paymentType => ({
        value: paymentType.code,
        label: paymentType.code,
      }))
      .sort((a, b) => selectSorterFunction(a.label, b.label)) || [];

  return (
    <Controller
      control={control}
      name="paymentTypes"
      render={({ field: { onChange, value } }): JSX.Element => (
        <Autocomplete
          multiple
          id="payment-types-select"
          options={paymentTypesOptions}
          size="small"
          sx={{ minWidth: 230, maxWidth: 230 }}
          limitTags={1}
          blurOnSelect={true}
          onChange={(_, newValue): void => onChange(newValue || [])}
          value={(value as unknown as { value: string; label: string }[]) || []}
          getOptionLabel={(option): string => option.label}
          isOptionEqualToValue={(option, value): boolean =>
            option.value === value.value
          }
          renderInput={(params): JSX.Element => (
            <HHTextField
              {...params}
              hhVariant="variant-bypass"
              variant="standard"
              label={StatusFilterLabelText.PAYMENT_TYPES}
              error={Object.keys(errors?.paymentTypes ?? {}).length !== 0}
              helperText={errors.paymentTypes?.message as string}
            />
          )}
        />
      )}
    />
  );
};
